import * as React from 'react';
import Box from '@mui/joy/Box';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import { BotRow } from './aggregate';

type Props = {
    rows: BotRow[];
    grandTotal: number;
};

export function botCardHref(botId: number): string {
    return `/app/bots/${botId}#stats`;
}

export function LoadShareBar(props: Props) {
    const { rows, grandTotal } = props;

    const dataset = React.useMemo(() => rows.slice(), [rows]);
    const maxTotal = React.useMemo(
        () => Math.max(...dataset.map((row) => row.total), 1),
        [dataset],
    );

    if (dataset.length === 0) {
        return null;
    }

    return (
        <Box>
            <Typography level="title-sm" sx={{ mb: 0.5 }}>
                Доля нагрузки за период
            </Typography>
            <Typography level="body-xs" sx={{ color: 'neutral.500', mb: 1 }}>
                {dataset.length} бот(ов). Клик по имени открывает карточку
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.75,
                    maxHeight: 640,
                    overflowY: 'auto',
                    pr: 0.5,
                }}
            >
                {dataset.map((row) => {
                    const barPct = (row.total / maxTotal) * 100;
                    const share = grandTotal ? (row.total / grandTotal) * 100 : 0;
                    return (
                        <Box
                            key={row.botId}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', sm: 'minmax(140px, 220px) 1fr auto' },
                                alignItems: 'center',
                                gap: { xs: 0.25, sm: 1 },
                            }}
                        >
                            <Link
                                level="body-sm"
                                href={botCardHref(row.botId)}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {row.label}
                            </Link>
                            <Box
                                sx={{
                                    height: 10,
                                    borderRadius: '4px',
                                    bgcolor: 'neutral.outlinedBorder',
                                    overflow: 'hidden',
                                }}
                            >
                                <Box
                                    sx={{
                                        height: '100%',
                                        width: `${barPct}%`,
                                        bgcolor: 'primary.500',
                                        borderRadius: '4px',
                                    }}
                                />
                            </Box>
                            <Typography
                                level="body-xs"
                                sx={{ color: 'neutral.600', whiteSpace: 'nowrap', justifySelf: 'end' }}
                            >
                                {row.total.toLocaleString('ru-RU')} ({share.toFixed(1)}%)
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
